import React from "react";
import { connect } from "react-redux";

import { faGear } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Switch from "antd/es/switch";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { Divider, Dropdown } from "@mapmycustomers/ui";

import {
  toggleDuplicateLeadsVisibility,
  toggleHiddenLeadsVisibility,
} from "@app/component/leadFinder/store/actions";
import {
  isHiddenLeadsVisible,
  isPotentialDuplicateLeadsVisible,
} from "@app/component/leadFinder/store/selectors";
import TextWithInfo from "@app/component/typography/TextWithInfo";
import { isLeadFinderBasic } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";

import messages from "./messages";
import styles from "./Title.module.scss";

interface Props {
  basicPlan: boolean;
  onToggleDuplicateLeadsVisibility: () => void;
  onToggleHiddenLeadsVisibility: () => void;
  showDuplicates?: boolean;
  showHidden?: boolean;
}

const Title = ({
  basicPlan,
  onToggleDuplicateLeadsVisibility,
  onToggleHiddenLeadsVisibility,
  showDuplicates,
  showHidden,
}: Props) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <span>{intl.formatMessage(basicPlan ? messages.titleBasic : messages.title)}</span>
      <Dropdown
        dropdownRender={() => (
          <div className={styles.dropdown}>
            <div className={styles.duplicateSwitch}>
              <span className={styles.subTitle}>{intl.formatMessage(messages.showDuplicates)}</span>
              <Switch checked={showDuplicates} onClick={onToggleDuplicateLeadsVisibility} />
            </div>
            <Divider className={styles.divider} />
            <div className={styles.hiddenSwitch}>
              <div className={styles.subTitleContainer}>
                <TextWithInfo info={intl.formatMessage(messages.hideToggleTooltip)}>
                  {intl.formatMessage(messages.showHiddenResults)}
                </TextWithInfo>
              </div>
              <Switch checked={showHidden} onClick={onToggleHiddenLeadsVisibility} />
            </div>
          </div>
        )}
        trigger={["click"]}
      >
        <Tooltip title={intl.formatMessage(messages.dropDownTooltip)}>
          <FontAwesomeIcon className={styles.icon} icon={faGear} />
        </Tooltip>
      </Dropdown>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  basicPlan: isLeadFinderBasic(state),
  showDuplicates: isPotentialDuplicateLeadsVisible(state),
  showHidden: isHiddenLeadsVisible(state),
});

const mapDispatchToProps = {
  onToggleDuplicateLeadsVisibility: toggleDuplicateLeadsVisibility,
  onToggleHiddenLeadsVisibility: toggleHiddenLeadsVisibility,
};

export default connect(mapStateToProps, mapDispatchToProps)(Title);
